<template>
  <div class="card-row card-row-show">
    <div class="card-header-col card-col w30">
      <Checkbox v-if="disabled" disabled :value="invoice.id" v-model="checked" />
      <Checkbox v-else @change="addInvoiceNo(invoice)" :value="invoice.id" v-model="checked" />
    </div>
    <div class="card-row-col card-col w120">
      <router-link
        :to="{
        name: 'InvoiceVoucher',
        params: { invoiceId: invoice.id, type: 'voucher' }
        }"
      >{{invoice.voucher_number}}</router-link>
    </div>
    <div class="card-row-col card-col w120">{{invoice.created_at | moment("DD MMM YYYY")}}</div>
    <div class="card-row-col card-col w150" v-if="invoice.invoice_numbers.length">
      <Popover placement="bottom-end" v-model="showInvoiceNo">
        <div class="payment-popover popover-primary">
          <div class="popover-primary-header">
            <h3>Details</h3>
            <span class="remove-icon" @click="showInvoiceNo=false">
              <svgicon name="cancel" width="10" height="10" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body table-popover tablepadding">
            <div class="popover-table">
              <div class="popover-table-header">
                <div class="card-col w200">Invoice number</div>
                <div class="card-col w150">Status</div>
                <div class="card-col w50"></div>
              </div>

              <div
                class="popover-table-row"
                v-for="(invoice, index) in invoice.invoice_numbers"
                :key="index"
              >
                <div class="card-col w200">{{invoice.invoice_number}}</div>
                <div
                  class="card-col w150"
                  :class="getClass(invoice.status)"
                >{{ $invoice.getStatusName(invoice.status)}}</div>
                <div
                  class="card-col w50"
                  :class="'verifiedcolor'"
                  v-if="$invoice.canEditInvoice(invoice.status)"
                >
                  <a class="action-accordian">
                    <router-link
                      target="_blank"
                      :to="{ name: 'InvoiceDetails', params: { invoiceId: invoice._id }}"
                    >
                      <svgicon
                        name="edit"
                        width="10"
                        height="10"
                        :original="true"
                        class="iconspace"
                      />Edit
                    </router-link>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="reference" class="pointer">
          {{(invoice.invoice_numbers.length) ? invoice.invoice_numbers[0].invoice_number : '--'}}
          {{(invoice.invoice_numbers.length > 1) ? `+ ${invoice.invoice_numbers.length - 1}`: ''}}
        </div>
      </Popover>
    </div>
    <div class="card-row-col card-col w160">
      <Ellipsis :text="invoice.transporter.name" :length="18" />
    </div>
    <div class="card-row-col card-col w150">{{invoice.transporter.ref_id}}</div>
    <div class="card-row-col card-col w120">{{invoice.transporter_amount}} INR</div>
    <div class="card-row-col card-col w120">{{invoice.amount}} INR</div>
    <div class="card-row-col card-col paymentvoucher-actions card-action">
    <div class="card-edit action" v-if="[7, 9, 10, 11].includes(invoice.status)">
      <Popover placement="bottom-end" trigger="click" v-model="docno">
        <div class="popover-primary">
          <div class="popover-primary-header">
            <h3>Document Number</h3>
            <span class="remove-icon" @click="docno=false">
              <svgicon name="cancel" width="10" height="10" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body" v-if="paymentUpdatedDates">
            <Documentnumber :paymentUpdatedDates="paymentUpdatedDates" />
          </div>
          <div v-else>Loading..</div>
        </div>
        <div slot="reference" @click="$emit('showDates', invoice.id)">
          <svgicon class="topmargin" name="documents" width="14" height="14" :original="true" />
          Doc No
        </div>
      </Popover>
    </div>
      <div class="card-edit action">
        <Popover placement="bottom-end" v-model="comment">
          <div class="popover-primary">
            <div class="popover-primary-header">
              <h3>Comments</h3>
              <span class="remove-icon" @click="comment=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body">
              <Comments
                :showForm="commentLoading"
                :comments="comments"
                v-on:addComment="addComment"
              />
            </div>
          </div>
          <div @click="loadComments()" slot="reference">
            <svgicon name="Comments" width="12" height="12" :original="true" />Comments
          </div>
        </Popover>
      </div>

      <a class="action-accordian">
        <router-link
          :to="{
           name: 'InvoiceVoucher',
           params: { invoiceId: invoice.id, type: 'voucher' }
           }"
        >
          <svgicon name="arrow-down" class="svg-left" width="12" height="12" :original="true" />
        </router-link>
      </a>
    </div>
  </div>
</template>
<script>
import Comments from '@/components/common/comments';
import Documentnumber from '@/components/modules/invoice/common/Documentnumber';

const invoiceStatusColor = [];
invoiceStatusColor[2] = 'neturalInvoice';
invoiceStatusColor[3] = 'greenInvoice';
invoiceStatusColor[4] = 'redInvoice';
invoiceStatusColor[7] = 'greenInvoice';
invoiceStatusColor[8] = 'redInvoice';
invoiceStatusColor[11] = 'greenInvoice';
invoiceStatusColor[12] = 'redInvoice';

export default {
  name: 'Row',
  components: {
    Comments,
    Documentnumber,
  },
  props: {
    invoice: Object,
    selected: Array,
    voucherVendorId: String,
    paymentUpdatedDates: Array,
    commentLoading: Boolean,
    comments: Array,
    voucher_updated_dates: Array,
  },
  data() {
    return {
      showLrDetails: false,
      showInvoiceNo: false,
      comment: false,
      showDates: false,
      docno: false,
      dateLabel: {
        processing: { name: 'POSTING', column: 'document_number' },
        payment_accepted: { name: 'CLEARANCE', column: 'clearance_doc_no' },
      },
      invoiceStatusColor: ['', ''],
    };
  },
  computed: {
    checked: {
      get() {
        return this.selected.includes(this.invoice.id);
      },
      set() {
        return false;
      },
    },
    disabled() {
      let forcedisable = false;
      if (
        this.voucherVendorId &&
        this.selected.length &&
        this.voucherVendorId !== this.invoice.transporter.id
      ) {
        forcedisable = true;
      }
      return forcedisable;
    },
  },
  methods: {
    getClass(status) {
      return invoiceStatusColor[status]
        ? invoiceStatusColor[status]
        : 'defaultInvoice';
    },
    addInvoiceNo(invoice) {
      this.$emit('addInvoice', invoice);
    },
    addComment(comment) {
      this.$emit('addConversation', {
        comment,
        id: this.invoice.id,
        section: 3,
      });
    },
    loadComments() {
      this.$emit('getComments', { id: this.invoice.id, section: 3 });
    },
  },
};
</script>
<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.handLink { cursor: pointer;}
.popover-primary {
  textarea {
    border: 1px solid #dee5e6;
    width: 100%;
    border-radius: 2px;
    padding: 10px;
    margin: 20px 0;
    outline: none;
  }
  .right-btn {
    float: right;
  }
}
.payment-actions {
  // width: 20%;
  text-align: right;
  .action {
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    text-transform: uppercase;
    &-accordian {
      cursor: pointer;
    }
    &-secondary {
      color: #404040;
      font-family:$fontSemibold;
      font-size: 1.2rem;
    }
  }
}
.invoice-action {
  width: calc(100% - 1230px);
  text-align: right;
}
.table-popover {
  position: relative;
  left: -10px;
}
.paymentvoucher-actions{
    width: calc(100% - 1035px);
    text-align: right;
    .action {
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    text-transform: uppercase;
  }
}
.action-accordian {
  a {
    color: #376f99;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    text-decoration: none;
  }
}
.iconspace {
  margin-right: 5px;
}
.tablepadding {
  padding: 10px;
}
.greenInvoice {
  color: #62a360 !important;
  text-transform: uppercase;
}
.redInvoice {
  color: #be3f4f !important;
  text-transform: uppercase;
}
.neturalInvoice {
  color: #50a6e3 !important;
  text-transform: uppercase;
}
.defaultInvoice {
  color: #777a78 !important;
  text-transform: uppercase;
}
</style>
